"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAnyNumber = exports.isManualPaymentMethod = exports.isDirectDebitPaymentMethod = exports.getFormattedFixedAndMsisdnAssociatedNumbers = exports.filterViewableBillingAccounts = exports.transformAssociatedNumbers = exports.getAccountNumbersLabel = void 0;
var common_utils_1 = require("@dch/common-utils");
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
// Ref: This seems specific to mobile ui, as in web we need to style differently the inner content of the label.
// It might need to be extracted.
/**
 * @deprecated
 */
function getAccountNumbersLabel(moreNumbersCount, mainAssociatedNumber, moreNumbersTranslation) {
    return {
        label: mainAssociatedNumber +
            (moreNumbersCount > 0 ? " + ".concat(moreNumbersCount, " ").concat(moreNumbersTranslation) : ''),
        pressable: moreNumbersCount > 0,
    };
}
exports.getAccountNumbersLabel = getAccountNumbersLabel;
function transformAssociatedNumbers(associatedNumbers, noFixedAndMsisdnTranslation, noProductLinkedTranslation) {
    var _a, _b, _c;
    var fixedNumbers = ((_a = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.fixed) !== null && _a !== void 0 ? _a : []).map(common_utils_1.formatNa);
    var msisdnNumbers = ((_b = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.msisdn) !== null && _b !== void 0 ? _b : []).map(function (msisdn) { return (0, common_utils_1.formatMsisdn)(msisdn); });
    var otherNumbers = (_c = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.other) !== null && _c !== void 0 ? _c : [];
    var moreAssociatedNumbers = [];
    var mainAssociatedNumber;
    if (fixedNumbers.length > 0) {
        mainAssociatedNumber = fixedNumbers[0];
        moreAssociatedNumbers.push.apply(moreAssociatedNumbers, __spreadArray(__spreadArray([], fixedNumbers.slice(1), false), msisdnNumbers, false));
    }
    else if (msisdnNumbers.length > 0) {
        mainAssociatedNumber = msisdnNumbers[0];
        moreAssociatedNumbers.push.apply(moreAssociatedNumbers, msisdnNumbers.slice(1));
    }
    else if (otherNumbers.length > 0) {
        mainAssociatedNumber = noFixedAndMsisdnTranslation;
    }
    else {
        mainAssociatedNumber = noProductLinkedTranslation;
    }
    return { mainAssociatedNumber: mainAssociatedNumber, moreAssociatedNumbers: moreAssociatedNumbers };
}
exports.transformAssociatedNumbers = transformAssociatedNumbers;
function isAccountActive(account) {
    var _a, _b, _c, _d;
    return (Number(account.balance) !== 0 ||
        ((_b = (_a = account.associatedNumbers) === null || _a === void 0 ? void 0 : _a.msisdn) !== null && _b !== void 0 ? _b : []).length > 0 ||
        ((_d = (_c = account.associatedNumbers) === null || _c === void 0 ? void 0 : _c.fixed) !== null && _d !== void 0 ? _d : []).length > 0);
}
function filtersOutLongFixedNumbers(billingAccount) {
    var _a, _b;
    if (((_a = billingAccount.associatedNumbers) === null || _a === void 0 ? void 0 : _a.fixed) !== undefined) {
        var accountWithFilteredFixedNumbers = (0, lodash_clonedeep_1.default)(billingAccount);
        /* istanbul ignore else - cloneDeep does not take into account that "fixed" field will never be undefined due to first if */
        if (((_b = accountWithFilteredFixedNumbers.associatedNumbers) === null || _b === void 0 ? void 0 : _b.fixed) !== undefined) {
            accountWithFilteredFixedNumbers.associatedNumbers.fixed =
                billingAccount.associatedNumbers.fixed.filter(function (value) { return value.length <= 10; });
        }
        return accountWithFilteredFixedNumbers;
    }
    return billingAccount;
}
function filterActiveAccounts(billingAccounts) {
    return billingAccounts.filter(isAccountActive).map(filtersOutLongFixedNumbers);
}
function filterInactiveAccountsWithOtherAssociatedNumbers(billingAccounts) {
    return billingAccounts.filter(function (billingAccount) { var _a, _b; return ((_b = (_a = billingAccount.associatedNumbers) === null || _a === void 0 ? void 0 : _a.other) !== null && _b !== void 0 ? _b : []).length > 0; });
}
/**
 * Returns active accounts (removes fixed numbers > 10 digits).
 * If none, fallbacks to inactive accounts with "other" associated numbers.
 */
function filterViewableBillingAccounts(billingAccounts) {
    var activeAccounts = filterActiveAccounts(billingAccounts);
    return activeAccounts.length > 0
        ? activeAccounts
        : filterInactiveAccountsWithOtherAssociatedNumbers(billingAccounts);
}
exports.filterViewableBillingAccounts = filterViewableBillingAccounts;
function getFormattedFixedAndMsisdnAssociatedNumbers(associatedNumbers) {
    var _a, _b;
    var fixed = (_a = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.fixed.map(function (fixedNumber) { return (0, common_utils_1.formatNa)(fixedNumber); })) !== null && _a !== void 0 ? _a : [];
    var msisdn = (_b = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.msisdn.map(function (msisdnNumber) { return (0, common_utils_1.formatMsisdn)(msisdnNumber); })) !== null && _b !== void 0 ? _b : [];
    return fixed.concat(msisdn);
}
exports.getFormattedFixedAndMsisdnAssociatedNumbers = getFormattedFixedAndMsisdnAssociatedNumbers;
function isDirectDebitPaymentMethod(paymentMethod) {
    return paymentMethod === 'DD' || paymentMethod === 'CC';
}
exports.isDirectDebitPaymentMethod = isDirectDebitPaymentMethod;
function isManualPaymentMethod(paymentMethod) {
    return paymentMethod === 'OK';
}
exports.isManualPaymentMethod = isManualPaymentMethod;
function hasAnyNumber(associatedNumbers) {
    var _a, _b, _c, _d, _e, _f;
    var fixedLength = (_b = (_a = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.fixed) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    var msisdnLength = (_d = (_c = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.msisdn) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    var otherLength = (_f = (_e = associatedNumbers === null || associatedNumbers === void 0 ? void 0 : associatedNumbers.other) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0;
    return fixedLength !== 0 || msisdnLength !== 0 || otherLength !== 0;
}
exports.hasAnyNumber = hasAnyNumber;
